var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 32.3195L37.658 36.5838L37.2344 37H18.829C15.4003 37 12.1843 36.0991 9.41451 34.5229C6.55626 32.9004 4.17251 30.5583 2.52121 27.75C2.28584 27.3559 2.06743 26.9508 1.86407 26.5364C0.670313 24.1055 0 21.3804 0 18.5C0 15.1312 0.916973 11.9713 2.52121 9.25C4.17251 6.4417 6.55626 4.0996 9.41451 2.47715C9.88523 2.20705 10.371 1.95915 10.8681 1.7316C13.2858 0.61975 15.984 0 18.829 0C22.2578 0 25.4738 0.90095 28.2435 2.47715C31.1018 4.0996 33.4855 6.4417 35.1368 9.25C36.7411 11.9713 37.658 15.1312 37.658 18.5C37.658 21.2954 37.0273 23.9464 35.8956 26.3218C35.8636 26.3939 35.8279 26.4661 35.794 26.5364H23.4948C26.2495 24.9898 28.1324 22.1149 28.2379 18.7978L28.2435 18.8034V18.5C28.2435 13.3921 24.0277 9.25 18.829 9.25H18.5202L18.5259 9.25555C13.4665 9.4128 9.41451 13.4921 9.41451 18.5C9.41451 21.941 11.3275 24.9436 14.1632 26.5364C15.5377 27.3097 17.1306 27.75 18.829 27.75H37.3492L42 32.3195Z",
    fill: "#4D4ABF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImage);
export default __webpack_public_path__ + "static/media/logo-image.09b96d8fc406d71b4d339c96da707b0e.svg";
export { ForwardRef as ReactComponent };